exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noSidebarContainer[data-v-caf72b22]{padding-inline:2%}.app-wrapper[data-v-caf72b22]{position:relative;height:100%;width:100%}.app-wrapper.mobile.openSidebar[data-v-caf72b22]{position:fixed;top:0}", ""]);

// exports
